import { render, staticRenderFns } from "./BoxSlideList.vue?vue&type=template&id=fa0663ca&scoped=true&"
import script from "./BoxSlideList.vue?vue&type=script&lang=ts&"
export * from "./BoxSlideList.vue?vue&type=script&lang=ts&"
import style0 from "./BoxSlideList.vue?vue&type=style&index=0&id=fa0663ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0663ca",
  null
  
)

export default component.exports